/* global axios */
import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, { emails });
  }

  get() {
    return axios.get(this.url);
  }

  create(agentParams) {
    return axios.post(this.url, { agent: agentParams });
  }

  update(id, agentParams) {
    return axios.patch(`${this.url}/${id}`, { agent: agentParams });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new Agents();
